module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Shutdown-5b01d8dee49970d75dea4747516ca72c.svg";